<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{ depth: number; hasNextSibling: boolean }>()
const levels = computed(() => props.depth - 1)
</script>

<template>
  <div class="flex flex-row">
    <template
      v-for="i in levels"
      :key="i"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="28"
        viewBox="0 0 20 28"
        fill="none"
        class="stroke-border focus-within:stroke-border"
      >
        <path
          v-if="i < levels"
          d="M10 16.9999L10 0L10 28"
        />
        <path
          v-else-if="hasNextSibling"
          d="M18 14V14C13.5817 14 10 10.4183 10 6L10 0L10 28"
        />
        <path
          v-else
          d="M10 0L10 5.99946C10 10.4177 13.5817 13.9995 18 13.9995V13.9995"
        />
      </svg>
    </template>
  </div>
</template>
